import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from "react";
import { useForm, useFormState } from "react-final-form";

import CompanyDelegatedInput from "./CompanyDelegatedInput";
import CompanyDetailsInput from "./CompanyDetailsInput";
import CompanyLegalRepInput from "./CompanyLegalRepInput";
import CompanyReferentInput from "./CompanyReferentInput";
import { get } from "lodash";
import { makeStyles } from "@material-ui/core";
import { useFieldLabel } from "ra-friendsofbabba";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  input: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    display: "inline-block",
    width: 350,
  },
  inputBlock: {
    display: "block",
    clear: "both",
  },
}));
const CompanyInput = ({
  type = "public",
  source,
  requiredValidator,
  showTitle = false,
  profile = false,
  showCompanyTypeSelector = true,
  ...props
}) => {
  const form = useForm();
  const classes = useStyles();
  const fieldLabel = useFieldLabel({ resource: "companies" });
  const formState = useFormState();
  const didMount = useRef(false);
  const { companyTypeId, companyTypeEntryId, municipalityId } = useMemo(
    () => ({
      companyTypeId: get(formState.values, `${source}.company_type_id`, 0),
      companyTypeEntryId: get(
        formState.values,
        `${source}.company_type_entry_id`,
        null
      ),
      municipalityId: get(formState.values, `${source}.municipality_id`, null),
    }),
    [formState.values, source]
  );
  const companyFieldLabel = useCallback(
    (name) => fieldLabel(`${companyTypeId}.${name}`),
    [fieldLabel, companyTypeId]
  );

  const representative = get(
    formState.values,
    `${source}.representative`,
    "legal_rep"
  );
  const { companyTypeEntry, municipality } = useSelector((state) => ({
    companyTypeEntry: get(
      state,
      `admin.resources.company-type-entries.data.${companyTypeEntryId}`
    ),
    municipality: get(
      state,
      `admin.resources.municipalities.data.${municipalityId}`
    ),
  }));

  useEffect(() => {
    if (type !== "public") {
      return;
    }
    form.change(`${source}.name`, companyTypeEntry?.name || "");
  }, [type, form, source, companyTypeEntry]);
  useEffect(() => {
    if (type !== "private") {
      return;
    }
    form.change(`${source}.city`, municipality?.name || "");
  }, [type, form, source, municipality]);
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    if (form.getFieldState(`${source}.company_type_id`)?.dirty) {
      form.change(`${source}.company_type_entry_id`, null);
    }
  }, [form, source, companyTypeId]);
  return (
    <Fragment>
      <CompanyDetailsInput
        {...props}
        type={type}
        classes={classes}
        source={source}
        fieldLabel={fieldLabel}
        companyTypeId={companyTypeId}
        companyFieldLabel={companyFieldLabel}
        showTitle={showTitle}
        showCompanyTypeSelector={showCompanyTypeSelector}
        requiredValidator={requiredValidator}
      />

      <CompanyLegalRepInput
        {...props}
        type={type}
        classes={classes}
        source={source}
        companyTypeId={companyTypeId}
        requiredValidator={requiredValidator}
        companyFieldLabel={companyFieldLabel}
      />
      {!profile && (
        <CompanyDelegatedInput
          {...props}
          type={type}
          classes={classes}
          source={source}
          representative={representative}
          companyTypeId={companyTypeId}
          requiredValidator={requiredValidator}
          companyFieldLabel={companyFieldLabel}
        />
      )}
      {!profile && (
        <CompanyReferentInput
          {...props}
          type={type}
          classes={classes}
          source={source}
          companyTypeId={companyTypeId}
          requiredValidator={requiredValidator}
          companyFieldLabel={companyFieldLabel}
        />
      )}
    </Fragment>
  );
};
export default CompanyInput;
